import api from "@/lib/api";

const DB = "bides-offline";
const STORE = "voice-notes";

const open = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id" });
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(out && "result" in out ? out.result : undefined);
    t.onerror = () => reject(t.error);
  });
};

export const queueVoiceNote = (note) => tx("readwrite", (s) => s.put({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, ...note }));
export const listQueuedNotes = () => tx("readonly", (s) => s.getAll()).then((r) => r || []);
const removeQueued = (id) => tx("readwrite", (s) => s.delete(id));

export const isNetworkError = (e) => !e?.response;

let flushing = false;
export async function flushVoiceQueue() {
  if (flushing || !navigator.onLine) return 0;
  flushing = true;
  let sent = 0;
  try {
    for (const n of await listQueuedNotes()) {
      try {
        await api.post("/voice-notes", n.blob, { headers: { "Content-Type": n.ctype }, params: { title: n.title || `Recorded offline ${new Date(n.recorded_at).toLocaleString("en-GB")}`, duration: n.duration } });
        await removeQueued(n.id);
        sent += 1;
      } catch (e) {
        if (isNetworkError(e)) break;
        if (e.response?.status === 400 || e.response?.status === 413) await removeQueued(n.id);
      }
    }
  } finally { flushing = false; }
  if (sent) window.dispatchEvent(new CustomEvent("voice-queue-flushed", { detail: sent }));
  return sent;
}
